import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'antd/es/form/Form';
import Title from 'antd/es/typography/Title';
import TextArea from 'antd/es/input/TextArea';
import { Button, Form, Modal, Rate, Select } from 'antd';
import { ProjectStatus, projectStatusOption } from '../../../utils/constant';
import { FieldBox } from '../ProjectStyle';
import { FlexWrapper } from '../../../theme/common_style';
import { toast } from 'react-toastify';
import { updateProjectStatusApi } from '../../../redux/project/apiRoute';

const ProjectStatusModal = ({ open, close, data, handleListing }) => {
  const [form] = useForm();
  const [loading, setLoading] = useState(false);

  const handleFinish = async (values) => {
    try {
      setLoading(true);
      const payload = {
        ...values,
        project_id: Number(data?.id)
      };
      let res = await updateProjectStatusApi(payload);
      if (res?.statusCode === 200) {
        toast.success(res?.message || 'Successfully updated');
        close();
        handleListing();
      } else {
        toast.error(res?.message || 'Something went wrong');
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        status: data.status,
        rating: data?.rating,
        feedback_note: data?.feedback_note || ''
      });
    }
  }, [data]);

  return (
    <Modal
      open={open}
      onCancel={close}
      centered
      // prefixCls="antCustomModal"
      width={700}
      destroyOnClose
      maskClosable={false}
      footer={false}>
      <Title level={4} style={{ margin: 0, textAlign: 'center' }}>
        Update Project Status
      </Title>
      <Form autoComplete="off" form={form} onFinish={handleFinish} style={{ margin: '20px 0' }}>
        {(values) => (
          <>
            <FieldBox>
              <label>
                Status<span>*</span>
              </label>
              <Form.Item name={'status'} style={{ width: '100%' }} rules={[{ required: true }]}>
                <Select
                  showSearch
                  allowClear
                  prefixCls="form-select"
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                  }
                  placeholder={`Select Status`}
                  options={projectStatusOption}
                />
              </Form.Item>
            </FieldBox>

            <FieldBox>
              <FlexWrapper justify="space-between" width="100%">
                <label>Note</label>
              </FlexWrapper>
              <Form.Item name="feedback_note">
                <TextArea rows={5} placeholder="Write Details here" />
              </Form.Item>
            </FieldBox>

            {values?.status === ProjectStatus.DELIVERED && (
              <FieldBox>
                <label>Rating</label>
                <Form.Item name="rating">
                  <Rate allowHalf />
                </Form.Item>
              </FieldBox>
            )}

            <Form.Item style={{ margin: 0 }}>
              <FlexWrapper justify="end" margin="20px 0 0">
                <Button
                  loading={loading}
                  htmlType="submit"
                  style={{ width: '140px' }}
                  prefixCls="antCustomBtn">
                  Submit
                </Button>
              </FlexWrapper>
            </Form.Item>
          </>
        )}
      </Form>
    </Modal>
  );
};

export default ProjectStatusModal;

ProjectStatusModal.propTypes = {
  open: PropTypes.bool,
  close: PropTypes.func,
  data: PropTypes.object,
  handleListing: PropTypes.func
};
